require('../css/normalize.css');
require('../css/flex.css');
require('../css/index.less');

$('.headers').load('header.html');
$('.footers').load('footer.html',function(){
	let timer = null;
	$('li.ywtx').hover(function(){
		clearInterval(timer);
		$(this).addClass('active');
	},function(){
		timer = setTimeout(() => {
			$(this).removeClass('active');
		},500);
	});
	$('li.contactUs').on('click',function(){
		let top = $('.contact').position().top;
		$(document).scrollTop(top);
	});
	let el = document.getElementById('year'),
		year = new Date().getFullYear();
	el.innerHTML = year;

});


$.ajax({
	url:'/css/index.css',
	type:'get',
	success:function(){
		$('body').removeClass('oh');
		$('.loadings').fadeOut(function(){
			$(this).remove();
		});
	},
	error:function(){
		$('body').removeClass('oh');
		$('.loadings').fadeOut(function(){
			$(this).remove();
		});
	}
});




